export const PINNED_BON_PRINTER_STORAGE_KEY = 'posPinnedBonPrinterId';

export function getPinnedBonPrinterId(): number | null {
  const raw = localStorage.getItem(PINNED_BON_PRINTER_STORAGE_KEY);
  if (!raw) return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}

export function setPinnedBonPrinterId(printerId: number): void {
  localStorage.setItem(PINNED_BON_PRINTER_STORAGE_KEY, String(printerId));
}

export function clearPinnedBonPrinterId(): void {
  localStorage.removeItem(PINNED_BON_PRINTER_STORAGE_KEY);
}

// Drops the groups bound for this device's pinned printer. The lines are still fired to the
// kitchen by the send request; only their paper bon is suppressed, which is what a red fire does.
// Must also be applied to expectedPrinterRoutes: the backend treats an expected route with no
// print job as a failure and force-queues it from another device.
export function withoutPinnedBonRoutes<T extends { printerId: number }>(routes: T[]): T[] {
  const pinnedPrinterId = getPinnedBonPrinterId();
  return pinnedPrinterId == null ? routes : routes.filter((route) => route.printerId !== pinnedPrinterId);
}
